import { useState, useEffect } from 'react';
function useDropdownDashboard(dataDropdown) {
    const [dropdownDefaultValue, setDropdownDefaultValue] = useState("");

    const modifyDropdownValues = (val) => {
        var choices = val ? val : null //getValues("value_dropdown");
        choices = choices?.split("|");
        if (choices == null || choices.join("").replace(/\s/g, '').length == 0) {
            setDropdownDefaultValue([{
                value: -1,
                text: <span> Nothing</span>
            }]);
            return;
        }
        var arrayChoices = [];

        for (var i = 0; i < choices.length; i++) {
            if (choices[i].replace(/\s/g, '').length == 0) continue
            arrayChoices.push(
                {
                    value: i,
                    text: <span>{choices[i]} </span>
                },
            )
        }
        setDropdownDefaultValue(arrayChoices);
    }

    useEffect(() => {
        modifyDropdownValues(dataDropdown);
    }, []);

    return { dropdownDefaultValue, modifyDropdownValues };
}

export default useDropdownDashboard;